import Marquee from '../components/ui/Marquee';

import AppleTV from '../assets/canal/Apple_TV.png';
import Arte from '../assets/canal/Arte.png';
import BeinSports from '../assets/canal/Bein_group.png';
import DAZN from '../assets/canal/DAZN.png';
import DisneyPlus from '../assets/canal/Disney+.png';
import HBOMax from '../assets/canal/HBO_Max.png';
import Hulu from '../assets/canal/Hulu.png';
import M6 from '../assets/canal/M6.png';
import MBCGroup from '../assets/canal/MBC_Group.png';
import Netflix from '../assets/canal/Netflix.png';
import OCS from '../assets/canal/OCS.png';
import PlutoTV from '../assets/canal/Pluto_TV.png';
import PrimeVideo from '../assets/canal/Prime_Video.png';
import RMC from '../assets/canal/RMC.png';
import CanalPlus from '../assets/canal/canal+.png';
import TF1 from '../assets/canal/tf1 .png';
import TF1Series from '../assets/canal/tf1 series films.png';
import W9 from '../assets/canal/w9 .png';

const CHANNELS = [
  { name: 'Canal+', logo: CanalPlus },
  { name: 'TF1', logo: TF1 },
  { name: 'M6', logo: M6 },
  { name: 'Netflix', logo: Netflix },
  { name: 'Prime Video', logo: PrimeVideo },
  { name: 'Disney+', logo: DisneyPlus },
  { name: 'beIN Sports', logo: BeinSports },
  { name: 'RMC', logo: RMC },
  { name: 'DAZN', logo: DAZN },
  { name: 'Apple TV+', logo: AppleTV },
  { name: 'HBO Max', logo: HBOMax },
  { name: 'Hulu', logo: Hulu },
  { name: 'OCS', logo: OCS },
  { name: 'Arte', logo: Arte },
  { name: 'W9', logo: W9 },
  { name: 'TF1 Séries Films', logo: TF1Series },
  { name: 'Pluto TV', logo: PlutoTV },
  { name: 'MBC Group', logo: MBCGroup },
];

/**
 * Channel logo strip.
 *
 * Replaces a GSAP timeline that chained setTimeout calls inside onComplete —
 * those timers were never cleared on resize and stacked up over time. A CSS
 * marquee is equivalent visually, costs no JavaScript and pauses on hover.
 */
export default function ChannelStrip() {
  return (
    <section className="border-y border-line bg-ink-900/50 py-12 md:py-16">
      <div className="container">
        <h2 className="mb-9 text-center text-sm font-bold uppercase tracking-[0.16em] text-content-subtle">
          Les chaînes et plateformes incluses dans votre abonnement
        </h2>
      </div>

      <Marquee
        items={CHANNELS}
        duration={45}
        gap="gap-12 md:gap-16"
        aria-label="Chaînes et plateformes incluses"
        renderItem={(channel) => (
          <img
            src={channel.logo}
            alt={channel.name}
            loading="lazy"
            decoding="async"
            className="h-8 w-auto max-w-[7.5rem] object-contain opacity-70 brightness-0 invert transition-opacity duration-300 hover:opacity-100 md:h-10"
          />
        )}
      />
    </section>
  );
}
